const Skeleton = ({ children }: { children?: React.ReactNode }) => (
  <div className="p-4 max-w-sm w-full mx-auto">
    <div className="animate-pulse space-x-4">
      <div className="space-y-4 py-1">
        <div className="h-4 bg-gray-300 rounded w-3/4"></div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-300 rounded"></div>
          <div className="h-4 bg-gray-300 rounded w-5/6"></div>
        </div>
      </div>
    </div>
    {children}
  </div>
);

export default Skeleton;
